import { render, staticRenderFns } from "./message-post-card.vue?vue&type=template&id=0f5693af&"
import script from "./message-post-card.vue?vue&type=script&lang=js&"
export * from "./message-post-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports